<template>
    <div class="FM_rateMonth">
        <!-- 设置月结费率 -->
        <el-card class="box-card tableCard" style="margin-top: 20px;" shadow="hover">
            <div style="font-size:15px;text-align: center;color:red">每月3号生效,请在此之前设置</div>
            <el-form ref="rateForm" class="rateForm">
                <div class="tableDiv" ref="tableDiv">
                    <table class="rateTable">
                        <tbody v-for="(item,index) in this.rateForm" :key="index" class='bk'>
                            <tr>
                                <td>
                                    <div style="font-weight:700">{{item.nickname}}</div>
                                </td>
                                <tbody v-for="(item1,index1) in item.brand" :key="index1">
                                    <tr>
                                        <td>
                                            <div style="font-weight:700">{{item1.name}}</div>
                                        </td>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div style="font-weight:700">正常</div>
                                                </td>
                                                <td>
                                                    <el-input v-model="item1.zc" placeholder="月结费率(‰)"></el-input>
                                                </td>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <el-button type="text" @click="getSecDebit(index,index1,item.agent_id,item1.id,101)">提交</el-button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div style="font-weight:700">小额双免</div>
                                                </td>
                                                <td>
                                                    <el-input v-model="item1.xesm" placeholder="月结费率(‰)"></el-input>
                                                </td>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <el-button type="text" @click="getSecDebit(index,index1,item.agent_id,item1.id,107)">提交</el-button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </tr>
                                        </tbody>
                                    </tr>
                                </tbody>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-form>
        </el-card>
    </div>
</template>
<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_rateMonth",
    data() {
        return {
            rateForm: {},
        }
    },
    components: {
        paginations,
    },
    mounted() {
        this.$api.post("user/agent_withdrawal_set", {}, res => {
            this.rateForm=res.data.list;
        });
    },
    methods: {
        getSecDebit(index,index1,agent_id, brand_id, pay_type) {
            console.log(this.rateForm)
            this.$api.post('user/agent_withdrawal_set_update', {index:index,index1:index1,agent_id:agent_id,brand_id:brand_id,pay_type:pay_type,rateForm:this.rateForm[index].brand[index1]}, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.$api.post("user/agent_withdrawal_set", {}, res => {
                        this.rateForm=res.data.list;
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>

<style lang="scss" scope>
.FM_rateMonth {
    font-size: 12px;
    .price {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        height: 50px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .el-card__header{
        background-color: bisque;
    }
    .el-col {
        margin: 10px 0;
    }
    .rightTitle {
        margin: 20px;
        :nth-child(1) {
            font-weight: 700;
        }
    }

    .bottom {
        .el-button {
            font-size: 12px;
        }
        display: flex;
        justify-content: flex-end;
    }
    //     .el-input__inner {
    //     border: none;
    //     text-align: center;
    //     font-size: 12px;
    // }
    .el-form-item {
        margin-bottom: 5px;
    }
    .el-switch__label *,
    .el-button--text {
        font-size: 12px;
    }
    .bk:nth-child(2n) {
    background-color: antiquewhite;
    }
    // .tableDiv {
        // overflow-x: scroll;
    // }
    .rateTable {
        // margin-top: 20px;
        border: 1px solid #ebeef5;
        display: table;
        border-collapse: separate;
        border-spacing: 2px;
        width: -webkit-fill-available;
        // width: 2000px;
        thead {
            color: #909399;
            font-weight: 500;
            th {
                border-bottom: 1px solid #ebeef5;
                border-right: 1px solid #ebeef5;
                // overflow: auto;
                padding: 12px 0;
                min-width: 150px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;
                font-size: 12px;
            }
        }
        tbody {
            display: table-row-group;
            vertical-align: middle;
            border-color: inherit;
            // :nth-last-child(1) td {
                // border-bottom: none;
            // }
            td {
                transition: background-color 0.25s ease;
                border-right: 1px solid #ebeef5;
                // border-bottom: 1px solid #ebeef5;
                // border-left: 1px solid #ebeef5;
                border-top: 1px solid #ebeef5;
                // padding: 12px 0;
                min-width: 200px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;
                font-size: 12px;
            }
            // tr {
            //     :nth-last-child(1) {
            //         border-right: none;
            //     }
            // }
        }
        td,
        th {
            display: table-cell;
            vertical-align: inherit;
        }
    }
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
}
</style>
